import theme from '../../../lib/theme';

const {
  scale,
  layouts,
  colors,
  media
} = theme;

export default () => ({
  shares: {
    marginLeft: `-${scale.xs}`,
    marginRight: `-${scale.xs}`,
    paddingLeft: scale.xs,
    paddingRight: scale.xs,
    border: 'none',

    [media.s.up]: {
      marginLeft: 0,
      marginRight: 0,
      paddingLeft: 0,
      paddingRight: 0,
    },
  },

  shareLink: {
    ...layouts.column,

    margin: `${scale.xxs} 0 ${scale.xxs} ${scale.xxs}`,
    textDecoration: 'none!important',
    cursor: 'pointer',
  },

  shareLinkImage: {
    boxSizing: 'content-box',
    width: 24,
    height: 24,
  },

  shareIcon: {
    fontSize: '1.5em!important',
    color: colors.black,

    '&:hover': {
      fontSize: '1.5em!important',
      color: colors.black,
    }
  }
});
